module.exports = "<symbol id=\"tt-icon-unhelpful-on\" viewBox=\"0 0 20 20\"><path d=\"M3.7 11.2c0 1 .5 1.4 1.1 1.6 2.1.4 4.9-.1 4.9-.1-.1.7-.1 1-.3 2.3-.2 1.3.4 2.4 1.2 3 1 .8 2.1-.1 2.1-.2 0 0-.1-1 0-1.8s.8-3 2-4.2c.3-.3.8-.7 1-1 1-2.8.5-5.7-.3-7.9-3.1-.8-8.6-.5-9.2-.2-.6.3-.8.9-.8 2.1-.8.6-1 1.3-.7 2.3-.7.3-1.1 1.8-.5 2.4-.4.8-.5 1.3-.5 1.7z\" fill=\"#1f5aa8\" xmlns=\"http://www.w3.org/2000/svg\"/></symbol>"


//////////////////
// WEBPACK FOOTER
// ./src/build/v6J5ZUpvDmQ7AMLsite/assets/svg/comments-pinboard-page/unhelpful-on.svg
// module id = 217
// module chunks = 11